export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--V.cfe6fbcb.png";